$ = require 'jquery'
View = require 'view'
entOrgPrefsNonorgInvites = require 'views/templates/ent_org_prefs_nonorg_invites'

module.exports = class OrganizationRestrictExternalMembersView extends View
  viewTitleKey: 'team board invitation restrictions'

  initialize: ->
    @listenTo @model, 'change:organizationPrefs', @frameDebounce @render

  events:
    'click a': 'changeRestriction'

  render: ->
    enterprise = @model.toJSON()

    @$el.html(entOrgPrefsNonorgInvites(enterprise))

    @

  changeRestriction: (e) ->
    $target = $(e.target)

    prefName = "externalMembersDisabled"
    setting = $target.closest('a').attr('data-restriction')

    isEnforcingSetting = @model.get('organizationPrefs').externalMembersDisabled?

    if setting == 'undefined'
      if isEnforcingSetting
        @model.deleteOrganizationPref(prefName)
    else
      settingIsTrue = (setting == 'true')
      @model.setOrganizationPref(prefName, settingIsTrue)



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/organization-restrict-external-members-view.coffee